import { InjectionToken, Injectable, inject } from '@angular/core';

import { SentryOptions } from '../../interfaces';
import { noop } from '../../utils';

export const CAPTURE_MESSAGE: InjectionToken<SentryLogger> = new InjectionToken('sentryCaptureMessage');

@Injectable({ providedIn: 'root' })
export class SentryLogger {
  private captureMessage: Function = inject<Function>(CAPTURE_MESSAGE, { optional: true }) ?? noop;

  error = (message: string, extra?: any): void => this.log(message, { level: 'error', extra });
  info = (message: string, extra?: any): void => this.log(message, { level: 'info', extra });
  warn = (message: string, extra?: any): void => this.log(message, { level: 'warning', extra });

  protected setCaptureMessage(_captureMessage: Function): void {
    this.captureMessage = _captureMessage;
  }

  private log(message: string, options: SentryOptions): void {
    this.captureMessage(message, options);
  }
}
